import { forwardRef, useEffect, useRef, useState } from "react";
import { getSrcSet, getSizes, buildCmsUrl } from "../../utils/imageHelper";



/*eslint-disable */

declare const window: any;

interface DiseñoVehiculosComponentProps {
  diseño: any;
}

const DiseñoVehiculosComponent = forwardRef<HTMLDivElement, DiseñoVehiculosComponentProps>(
  ({ diseño }, ref) => {
    const [visibleItems, setVisibleItems] = useState<number[]>([]);
    const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
    const [scrollPosition, setScrollPosition] = useState(0);

    const handleScroll = () => {
      setScrollPosition(window.pageYOffset);
    };

    useEffect(() => {
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);

    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const index = parseInt(entry.target.getAttribute("data-index") || "");

            if (entry.isIntersecting) {
              setVisibleItems((prev) => [...prev, index]);
            } else if (entry.boundingClientRect.top > 0) {
              setVisibleItems((prev) => prev.filter((item) => item !== index));
            }
          });
        },
        {
          threshold: 0.1,
        }
      );

      const timeoutId = setTimeout(() => {
        itemRefs.current.forEach((ref) => {
          if (ref) {
            observer.observe(ref);
          }
        });
      }, 100);

      return () => {
        clearTimeout(timeoutId);
        itemRefs.current.forEach((ref) => {
          if (ref) {
            observer.unobserve(ref);
          }
        });
      };
    }, [diseño]);

    return (
      <div className="diseño-vehiculos-detail-component" ref={ref}>
        {/* TÍTULO PRINCIPAL - H2 */}
        <h2 className="title-diseño-vehiculos-detail-component">
          {diseño?.title}
        </h2>
        
        {diseño?.contenido?.map((item: any, index: number) => (
          <div
            ref={(el) => (itemRefs.current[index] = el)}
            data-index={index}
            className={`${item?.format !== "wide" ? "small-diseño-vehiculos-detail-component" : "large-diseño-vehiculos-detail-component"} ${item.format} ${visibleItems.includes(index) ? "visible" : ""}`}
            key={index}
          >
            <div className={item.format !== "wide" ? `asset-small-diseño-vehiculos-detail-component` : `asset-large-diseño-vehiculos-detail-component`}>
              {item?.media_type === "video" ? (
                <video
                  className="active-video-banner-home-component"
                  src={buildCmsUrl(item?.media?.url)}

                  autoPlay
                  muted
                  loop
                  playsInline
                />
              ) : (
                <img 
                  src={buildCmsUrl(item?.media?.url)} 

                  srcSet={getSrcSet(item?.media?.url || '')}
                  sizes={getSizes(item?.format === 'wide' ? '1200px' : '600px')}
                  alt={item?.title || "Imagen del diseño del vehículo Hyundai"} 
                />

              )}
            </div>
            
            <div className={item?.format !== "wide" ? `text-small-diseño-vehiculos-detail-component` : `text-large-diseño-vehiculos-detail-component`}>
              {/* TÍTULO DEL ITEM - H3 (para ambos formatos) */}
              <h3 className={item?.format !== "wide" ? `title-text-small-diseño-vehiculos-detail-component` : `title-text-large-diseño-vehiculos-detail-component`}>
                {item?.title}
              </h3>
              
              <div className={item?.format !== "wide" ? `description-text-small-diseño-vehiculos-detail-component` : `description-text-large-diseño-vehiculos-detail-component`}>
                {item?.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
);

export default DiseñoVehiculosComponent;